import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useV2ProductRegulationSection } from './context'
import { RegulationEmptyPanel } from './RegulationEmptyPanel'
import { getRegulationEmptyStateKey } from './utils'

export function V2ProductRegulationSectionPendingQuestionsEmpty() {
  const {
    applicability,
    isLoading,
    questionnaireEditDisabled,
    openQuestionnaire,
  } = useV2ProductRegulationSection()
  const { t } = useTranslation('common')

  if (isLoading || applicability?.status !== 'NEEDS_GRILLING') {
    return null
  }

  const emptyStateKey = getRegulationEmptyStateKey(applicability)
  const title = t(
    `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.title`
  )
  const fallbackDescription = t(
    `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.description`
  )
  const trimmedGrillingSummary = applicability.grillingSummary?.trim() ?? ''
  let description = fallbackDescription
  if (trimmedGrillingSummary !== '') {
    description = trimmedGrillingSummary
  }

  return (
    <RegulationEmptyPanel
      title={title}
      description={description}
      action={
        <Button
          type='button'
          size='sm'
          disabled={questionnaireEditDisabled}
          onClick={openQuestionnaire}
        >
          {t('v2.applicability.pendingQuestions.openSheet')}
        </Button>
      }
    />
  )
}
